<script>
  import { onMount } from "svelte";
  import { Chart } from "chart.js";

  let { data, chartDateLabels, isInModal = false } = $props();

  let postsChart = $state(null);
  let canvasId = `postsChart_${Math.random().toString(36).substr(2, 9)}`;

  function setupPostsChart() {
    let snapspotData = $state.snapshot(data?.posts_count_growth);

    const postsCtx = document.getElementById(canvasId).getContext("2d");

    postsChart = new Chart(postsCtx, {
      type: "line",
      data: {
        labels: chartDateLabels(snapspotData?.dates || []),
        datasets: [
          {
            label: "Posts",
            data: snapspotData?.posts_count || [],
            fill: true,
            backgroundColor: "rgba(59, 130, 246, 0.2)",
            borderColor: "rgba(59, 130, 246, 1)",
            tension: 0.4,
            pointBackgroundColor: "rgba(59, 130, 246, 1)",
            pointBorderColor: "#fff",
            pointBorderWidth: 2,
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: false,
          },
        },
        scales: {
          y: {
            beginAtZero: false,
            ticks: {
              callback: function (value) {
                return Math.round(value).toLocaleString();
              },
            },
            grid: {
              color: "rgba(0, 0, 0, 0.1)",
            },
          },
          x: {
            grid: {
              color: "rgba(0, 0, 0, 0.1)",
            },
          },
        },
      },
    });
  }

  function updatePostsChart() {
    if (!postsChart) return;

    let snapspotData = $state.snapshot(data?.posts_count_growth || {});
    postsChart.data.labels = chartDateLabels(snapspotData?.dates || []);
    postsChart.data.datasets[0].data = snapspotData?.posts_count || [];

    postsChart.update();
  }

  $effect(() => {
    updatePostsChart();
  });

  // Resize chart when modal visibility changes
  $effect(() => {
    if (isInModal && postsChart) {
      setTimeout(() => {
        postsChart.resize();
      }, 100);
    }
  });

  onMount(() => {
    setupPostsChart();

    return () => {
      if (postsChart) postsChart.destroy();
    };
  });
</script>

<div class="bg-white shadow rounded-lg p-6">
  <h3 class="text-lg font-medium text-gray-900 mb-4">
    Posts Count Growth {@html data?.posts_count_growth?.dates?.length < 3
      ? "<span class='text-gray-500 text-xs pl-1'>(more data will be collected over time)</span>"
      : ""}
  </h3>
  <div class={isInModal ? "h-96" : "h-64"}>
    <canvas id={canvasId}></canvas>
  </div>
</div>
